<script>
  import { readable } from 'svelte/store'

  import { isHidden } from '$lib/Intercom.svelte'

  export let window = false

  let scrollY, innerHeight

  const isLarge = readable(false, (set) => {
    if (typeof matchMedia !== 'function') return
    const media = matchMedia('(min-width: 900px)')
    media.addEventListener('change', () => set(media.matches))
    set(media.matches)
  })

  $: $isHidden = window && !$isLarge && scrollY < innerHeight * 0.25
</script>

<svelte:window bind:scrollY bind:innerHeight />

<div class="hero" class:window>
  <div class="content">
    <div class="background"><slot name="background" /></div>
    <div class="children"><slot /></div>
  </div>
</div>

<style>
  .hero {
    --layers-height: 100%;
    --top-offset: 11rem;
    --bottom-offset: 7rem;
    --current-color: rgb(var(--rgb-white));

    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    background: rgb(var(--rgb-blue));
  }

  @media (width > 700px) {
    .hero {
      --top-offset: 11rem;
      --bottom-offset: 9rem;
    }
  }

  @media (min-height: 900px) {
    .hero {
      min-height: 40rem;
    }
  }

  .content {
    display: flex;
    align-items: flex-end;
    flex: 1 1 auto;
    width: 100%;
    padding: var(--top-offset) var(--document-margin) var(--bottom-offset);
    margin: 0 auto;
    max-width: calc(
      var(--container-large-width) + (var(--document-margin) * 2)
    );
    min-height: 30rem;
  }

  @media (width > 900px) {
    .content {
      align-items: center;
    }
  }

  .background {
    --rgb-image-background: var(--rgb-blue);

    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: var(--layers-height) !important;
    overflow: hidden;
    user-select: none;
  }

  @keyframes background--zoom {
    100% {
      transform: scale(1.03);
    }
  }

  @keyframes background--fadein {
    100% {
      opacity: 1;
    }
  }

  .children {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    position: relative;
  }

  .hero :global(:has(.background img) .background::after) {
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    pointer-events: none;
    background:
      radial-gradient(
        80% 50% at 30% 55%,
        rgba(0, 0, 0, 0.3) 0%,
        rgba(0, 0, 0, 0) 100%
      ),
      rgba(3, 0, 25, 0.3);
    background-repeat: no-repeat;
  }

  /* Window */

  .window {
    --current-border-radius: 0 0 2rem 2rem;
    --layers-height: calc(100% + 2rem);

    min-height: 100vh;
    min-height: calc(100svh + 2rem);
    padding-bottom: 2rem;
    border-radius: var(--current-border-radius);
    overflow: hidden;
  }

  @media (width > 900px) {
    .window {
      --layers-height: 100%;
      --current-border-radius: 2rem;

      padding-bottom: 0;
      margin: 0.75rem 0.75rem 0;
      width: calc(100% - 1.5rem);
      min-height: calc(100vh - 1.5rem);
    }
  }

  .window .content {
    max-width: none;
    padding: 7rem 1rem 1rem;
    align-items: initial;
    margin: 0 auto;
    flex: 1;
  }

  @media (width > 900px) {
    .window .content {
      padding: var(--top-offset) calc(var(--document-margin) - 0.75rem)
        var(--bottom-offset);
    }

    .window .children {
      padding: 1rem 0;
    }
  }

  @media (width > 900px) {
    .window .content {
      padding-right: 5.25rem;
      padding-left: 5.25rem;
    }
  }

  @media (width > 900px) {
    .window .background::after {
      background:
        radial-gradient(at 20%, rgba(19, 0, 50, 0.25) 0%, transparent),
        linear-gradient(rgba(19, 0, 50, 0.05) 0%, transparent 50%) !important;
    }
  }
</style>
